import VectorLayer from "ol/layer/Vector";
import VectorSource from "ol/source/Vector";

import { INSPECT_LAYER_NAME } from "./constants";

export default function createInspectLayer() {
  return new VectorLayer({
    // @ts-expect-error -  bad typing in ol custom prop are allowed
    name: INSPECT_LAYER_NAME,
    source: new VectorSource({
      // [MAPSETW-446] To make sure we don't use the rbush tree.
      useSpatialIndex: false,
    }),
    updateWhileAnimating: true,
    updateWhileInteracting: true,
    visible: false,
    zIndex: 100,
  });
}
